import {createSlice,createEntityAdapter,EntityState,} from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import {CaseStageEnum,CaseStageConfig,} from "../../../api/caseStages";

import { fetchStageConfigs } from "./thunks";

const stageConfigEntityAdapter = createEntityAdapter<
  CaseStageConfig,
  CaseStageEnum
>({
  selectId: (config) => config.stage,
});

interface CaseStagesConfigState {
  stageConfigs: EntityState<CaseStageConfig, CaseStageEnum>;
  loadingStatus: "idle" | "pending" | "succeeded" | "failed";
  error: string | null;
}

const initialState: CaseStagesConfigState = {
  stageConfigs: stageConfigEntityAdapter.getInitialState(),
  loadingStatus: "idle",
  error: null,
};

const caseStageConfigSlice = createSlice({
  name: "caseStageConfigs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStageConfigs.pending, (state) => {
        state.loadingStatus = "pending";
        state.error = null;
      })
      .addCase(fetchStageConfigs.fulfilled, (state, action) => {
        state.loadingStatus = "succeeded";
        stageConfigEntityAdapter.setAll(
          state.stageConfigs,
          action.payload
        );
      })
      .addCase(fetchStageConfigs.rejected, (state, action) => {
        state.loadingStatus = "failed";
        state.error =
          action.payload ?? "Failed to fetch stage configs";
      });
  },
});

export const caseStageConfigReducer = caseStageConfigSlice.reducer;

const { selectById } = stageConfigEntityAdapter.getSelectors<RootState>(
  (state) => state.caseStageConfigs.stageConfigs
);

export const selectStageConfigByStage = (stage: CaseStageEnum) => {
  return (state: RootState) => {
    return selectById(state, stage);
  }
}